import jobs from 'containers/JobsPage/reducer';
import job from 'containers/JobPage/reducer';

export default {
  jobs,
  job,
};
